var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBritichFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2146_22716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42857 0.859375H18.5714C19.3604 0.859375 20 1.49897 20 2.28795V13.7165C20 14.5055 19.3604 15.1451 18.5714 15.1451H1.42857C0.639593 15.1451 0 14.5055 0 13.7165V2.28795C0 1.49897 0.639593 0.859375 1.42857 0.859375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2146_22716)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42857 0.859375H18.5714C19.3604 0.859375 20 1.49897 20 2.28795V13.7165C20 14.5055 19.3604 15.1451 18.5714 15.1451H1.42857C0.639593 15.1451 0 14.5055 0 13.7165V2.28795C0 1.49897 0.639593 0.859375 1.42857 0.859375Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2146_22716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42857 0.859375H18.5714C19.3604 0.859375 20 1.49897 20 2.28795V13.7165C20 14.5055 19.3604 15.1451 18.5714 15.1451H1.42857C0.639593 15.1451 0 14.5055 0 13.7165V2.28795C0 1.49897 0.639593 0.859375 1.42857 0.859375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2146_22716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.859375H20V15.1451H0V0.859375Z",
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9161 -0.507812L12.381 5.24918V-0.0913054H7.61904V5.24918L-0.916025 -0.507812L-1.98117 1.0713L4.76697 5.62298H4.57764e-05V10.3849H4.76697L-1.98117 14.9366L-0.916025 16.5157L7.61904 10.7587V16.0991H12.381V10.7587L20.9161 16.5157L21.9812 14.9366L15.2331 10.3849H20V5.62298H15.2331L21.9812 1.0713L20.9161 -0.507812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66553 5.38125L-2.38112 -0.570312",
    stroke: "#DB1F35",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70508 10.6406L-2.40478 16.1069",
    stroke: "#DB1F35",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2817 5.3651L22.741 -0.335938",
    stroke: "#DB1F35",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3642 10.5781L22.741 16.7964",
    stroke: "#DB1F35",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.4308H11.4286V15.1451H8.57143V9.4308H0V6.57366H8.57143V0.859375H11.4286V6.57366H20V9.4308Z",
    fill: "#E6273E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritichFlag);
export default __webpack_public_path__ + "static/media/britichFlag.7bad80bbba7ed95df81abdac1295b569.svg";
export { ForwardRef as ReactComponent };